import React from "react";
import { View, StyleSheet } from "react-native";
import NtRootPageContainer from "../../root/components/NtRootPageContainer";
import NtPageActionButton from "../../components/NtPageActionButton";
import NtPageSection from "../../components/NtPageSection";
import NtPagination from "../../components/NtPagination";
import NtSearchBar from "../../components/NtSearchBar";
import NtTabController from "../../components/NtTabController";
import NtListHeader from "../../components/NtListHeader";
import NtListEmpty from "../../components/NtListEmpty";
import NtModal from "../../components/NtModal";
import { fetchPins } from "../../api/billing";
import NtPinManagementItem from "../components/NtPinManagementItem";
import NtPinManagementNewForm from "../components/NtPinManagementNewForm";
import NtPinmanagementUploadForm from "../components/NtPinManagementUploadForm";
import NtPinmanagementAdvanceSearchPicker from "../components/NtPinManagementAdvanceSearchPicker";
import NtArchiveCabinDataAllForm from "../components/NtArchiveCabinDataAllForm";
import {
  asyncStorageSetData,
  parseDecimalPlaces,
  parseSimpleDisplayDate,
  showToast,
} from "../../common/utils/ControllerUtils";
import Logger from "../../common/utils/Logger";
import settings from "../../config/settings";
import pincsvcolumndata from "../data/pincsvcolumdata";
import pintypesdata from "../data/pintypesdata";
import BasePinController from "./BasePinController";
import { fetchCurrency } from "../utils/CurrencyParser";

class PinManagementController extends BasePinController {
  state = {
    ...super.state,
    loading: false,
    data: [],
    totalItems: 0,
    searchText: "",
    searchFilter: null,
    selectedTab: null,
    page: 1,
  };

  column_location = "@pin_column_storage";
  addAccessModalRef = React.createRef();
  uploadAccessModalRef = React.createRef();
  archiveCabinDataModalRef = React.createRef();
  advanceSearchRef = React.createRef();

  tabs = [
    { id: "all", title: "All" },
    { id: "active", title: "Active" },
    { id: "inactive", title: "Inactive" },
  ];

  componentDidMount() {
    this.setState({ selectedTab: this.tabs[0] });
    this.handleDefaultColumnsFetch(
      this.column_location,
      pincsvcolumndata.filter((each) => each.default === true),
    );
    this.handleDataFetch();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.route.params !== this.props.route.params) {
      this.setState({ page: 1 }, () => this.handleDataFetch());
    }
  }


  handleDataFetch = async () => {
    this.setState({ loading: true });
    const response = await fetchPins(
      this.context.user?.domain,
      this.state.page,
      settings.pageSizeLoad,
      this.state.searchText,
      this.generateFullFilter(),
    );
    Logger("Pins fetch response", response);
    if (response.ok) {
      this.setState({
        data: response.data?.data || [],
        totalItems: response.data?.total || 0,
      });
    }
    this.setState({ loading: false });
  };

  handleExportFetch = async () => {
    const response = await fetchPins(
      this.context.user?.domain,
      1,
      10000000,
      this.state.searchText,
      this.generateFullFilter(),
    );
    return response.ok ? response.data.data : [];
  };

  handleExportDataParce = (item, column) => {
    if (column === "credit" || column === "initialbalance") {
      return item.type === "admin"
        ? "N/A"
        : `${fetchCurrency(item?.currency)?.symbol}${parseDecimalPlaces(item[column])}`;
    }
    if (column === "expirationdate" || column === "creationdate" || column === "lastuse") {
      return item[column] ? parseSimpleDisplayDate(item[column]) : "N/A";
    }
    if (column === "status") return item[column] == 1 ? "Active" : "Inactive";
    return item[column];
  };

  handleTypeFetch = () =>
    pintypesdata.find((each) => each.id === this.props.route?.params?.type);

  handleSearch = (text) => {
    this.setState({ searchText: text, page: 1 }, () => this.handleDataFetch());
  };

  handlePageChange = (nextPage) => {
    this.setState({ page: nextPage }, () => this.handleDataFetch());
  };

  handleTabChange = (tab) => {
    if (tab?.id === this.state.selectedTab?.id) return;
    this.setState(
      { selectedTab: tab, searchText: "", data: [], page: 1 },
      () => this.handleDataFetch(),
    );
  };

  generateFullFilter = () => {
    let filter = this.state.searchFilter ? { ...this.state.searchFilter } : {};
    filter.status = this.state.selectedTab?.id;
    filter.type = this.props.route?.params?.type;
    return filter;
  };

  renderAddNewForm = () => (
    <NtModal ref={this.addAccessModalRef}>
      <NtPinManagementNewForm
        type={this.handleTypeFetch()}
        onCancel={() => this.addAccessModalRef.current?.dismiss()}
        onCreate={() => {
          this.setState(
            { selectedTab: this.tabs[0], searchText: "", searchFilter: null, page: 1 },
            () => this.handleDataFetch(),
          );
          this.addAccessModalRef.current?.dismiss();
          showToast("Success", "Successfully created a new record");
        }}
      />
    </NtModal>
  );

  renderUploadForm = () => (
    <NtModal ref={this.uploadAccessModalRef}>
      <NtPinmanagementUploadForm
        type={this.handleTypeFetch()}
        onCancel={() => this.uploadAccessModalRef.current?.dismiss()}
        onUploaded={() => {
          this.setState({ page: 1 }, () => this.handleDataFetch());
          this.uploadAccessModalRef.current?.dismiss();
        }}
      />
    </NtModal>
  );

  renderArchiveCabinDataAllForm = () => (
    <NtModal ref={this.archiveCabinDataModalRef}>
      <NtArchiveCabinDataAllForm
        onDone={() => this.archiveCabinDataModalRef?.current?.dismiss()}
        onCancel={() => this.archiveCabinDataModalRef?.current?.dismiss()}
      />
    </NtModal>
  );

  renderAdvanceSearchForm = () => (
    <NtModal ref={this.advanceSearchRef}>
      <NtPinmanagementAdvanceSearchPicker
        type={this.props.route?.params?.type}
        filter={this.state.searchFilter}
        onCancel={() => this.advanceSearchRef.current?.dismiss()}
        onFilter={(filter) => {
          this.setState({ searchFilter: filter, page: 1 }, () => this.handleDataFetch());
          this.advanceSearchRef.current?.dismiss();
        }}
        onFilterClear={() => {
          this.setState({ searchFilter: null, page: 1 }, () => this.handleDataFetch());
          this.advanceSearchRef.current?.dismiss();
        }}
      />
    </NtModal>
  );

  renderRow = (item, index) => (
    <NtPinManagementItem
      key={item.id}
      item={item}
      type={this.props.route?.params?.type}
      columns={this.state.columns}
      onUpdate={() => {
        this.setState({ page: 1 }, () => this.handleDataFetch());
        showToast("Success", "Successfully updated the record");
      }}
      onReset={() => {
        this.setState({ page: 1 }, () => this.handleDataFetch());
        showToast("Success", "Successfully Reset the record");
      }}
    />
  );

  render() {
    const type = this.handleTypeFetch();
    const routeKey = `${this.props.route?.name}/${this.props.route?.params?.type}`;
    const canView = this.handlePermissionCheck(settings.permissionTypeView, routeKey);
    const canEdit = this.handlePermissionCheck(settings.permissionTypeEdit, routeKey);
    const count = this.state.totalItems || 0;
    const subtitle = `Calling-card PINs for guest and crew dialing · ${count} record${count === 1 ? "" : "s"}`;

    const actions = canEdit ? (
      <>
        {type && (
          <NtPageActionButton
            icon="plus"
            title={type?.id === "admin" ? "Add Admin Pin" : "Add Cabin"}
            variant="primary"
            onPress={() => this.addAccessModalRef.current?.show()}
          />
        )}
        {type && (
          <NtPageActionButton
            icon="arrow-up"
            title={
              type?.id === "admin"
                ? `Upload Multiple ${type?.title} Pins`
                : `Upload Multiple ${type?.title}s`
            }
            onPress={() => this.uploadAccessModalRef.current?.show()}
          />
        )}
        {this.props.route?.params?.type === "cabin" && (
          <NtPageActionButton
            icon="archive"
            title="Reset Billing Period"
            onPress={() => this.archiveCabinDataModalRef.current?.show()}
          />
        )}
      </>
    ) : null;

    const filters = (
      <NtTabController
        options={this.tabs}
        selection={this.state.selectedTab}
        onPress={this.handleTabChange}
      />
    );

    const searchBar = (
      <NtSearchBar
        filterCount={this.state.searchFilter ? Object.keys(this.state.searchFilter).length : 0}
        value={this.state.searchText}
        onChangeText={this.handleSearch}
        onFilterPress={() => this.advanceSearchRef?.current?.show()}
      />
    );

    return (
      <NtRootPageContainer
        pageTitle={`${type?.title || "Pin"} Management`}
        pageSubtitle={subtitle}
        permission={canView}
        actions={actions}
      >
        <NtPageSection
          filters={filters}
          search={searchBar}
          footer={
            <NtPagination
              page={this.state.page}
              pageSize={settings.pageSizeLoad}
              total={this.state.totalItems}
              onChange={this.handlePageChange}
            />
          }
        >
          <View style={styles.tableWrap}>
            <NtListHeader
              visible={this.state.data?.length > 0}
              headerContainerStyle={{ marginRight: canEdit ? 35 : 0 }}
              columns={pincsvcolumndata}
              selectedColumns={this.state.columns}
              onColumnUpdate={(updated) => {
                asyncStorageSetData(this.column_location, updated);
                this.setState({ columns: updated });
              }}
              overideColumnName={[
                {
                  id: "pin",
                  title: this.props.route?.params?.type === "cabin" ? type?.title : "Pin",
                },
              ]}
              exportFileName="pin"
              exportDataParser={this.handleExportDataParce}
              exportFetchDataAsync={this.handleExportFetch}
            />
            <NtListEmpty visible={this.state.data?.length === 0} />
            {this.state.data?.map((each, index) => this.renderRow(each, index))}
          </View>
        </NtPageSection>

        {this.renderAddNewForm()}
        {this.renderUploadForm()}
        {this.renderArchiveCabinDataAllForm()}
        {this.renderAdvanceSearchForm()}
      </NtRootPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  tableWrap: { paddingHorizontal: 14, paddingVertical: 4 },
});

export default PinManagementController;
